import { render, staticRenderFns } from "./CustomerHubActivity.vue?vue&type=template&id=0a2cbb2a&scoped=true"
import script from "./CustomerHubActivity.vue?vue&type=script&lang=js"
export * from "./CustomerHubActivity.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubActivity.vue?vue&type=style&index=0&id=0a2cbb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2cbb2a",
  null
  
)

export default component.exports